import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { Toaster } from 'sonner';

const root = createRoot(document.getElementById('root'));
root.render(
  <StrictMode>
    <App />
    <Toaster
      position="top-right"
      toastOptions={{
        style: {
          background: '#F2F0E9',
          color: '#1A1A1A',
          border: '1px solid #D6D3C9',
          fontFamily: 'Montserrat, sans-serif',
        },
      }}
    />
  </StrictMode>
);
// comment